module.exports = __webpack_public_path__ + "img/symbol_8.761b2d34.png";